export function LogoMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="1.5" width="21" height="21" rx="2.5" stroke="var(--color-brand)" strokeWidth="1.5"/>
      <rect x="29.5" y="1.5" width="21" height="21" rx="2.5" fill="var(--color-brand-dim)" stroke="var(--color-brand)" strokeWidth="1.5"/>
      <rect x="1.5" y="29.5" width="21" height="21" rx="2.5" fill="var(--color-brand-dim)" stroke="var(--color-brand)" strokeWidth="0.75" strokeDasharray="3 2.5" opacity={0.6}/>
      <rect x="29.5" y="29.5" width="21" height="21" rx="2.5" stroke="var(--color-brand)" strokeWidth="1.5" fill="var(--color-brand-dim)"/>
      <line x1="22.5" y1="12" x2="29.5" y2="12" stroke="var(--color-brand)" strokeWidth="1" opacity={0.45}/>
      <line x1="12" y1="22.5" x2="12" y2="29.5" stroke="var(--color-brand)" strokeWidth="1" opacity={0.45}/>
      <line x1="40" y1="22.5" x2="40" y2="29.5" stroke="var(--color-brand)" strokeWidth="1" opacity={0.45}/>
      <line x1="22.5" y1="40" x2="29.5" y2="40" stroke="var(--color-brand)" strokeWidth="1" opacity={0.45}/>
      <circle cx="40" cy="40" r="2" fill="var(--color-brand)"/>
      <circle cx="40" cy="12" r="2" fill="var(--color-brand)" opacity={0.8}/>
      <circle cx="12" cy="12" r="2" fill="var(--color-brand)" opacity={0.45}/>
    </svg>
  );
}

export function Logo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
      <LogoMark size={28} />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span className="logo-ai">AI</span>
        <span className="logo-dev">DEV</span>
      </div>
    </div>
  );
}
